module.exports = __webpack_public_path__ + "static/phone-print-62134b6b304fe4cf6c7a08e3d62575c4.png";